import { render, staticRenderFns } from "./HotkeyLegend.vue?vue&type=template&id=2959afc1&scoped=true&"
import script from "./HotkeyLegend.vue?vue&type=script&lang=ts&"
export * from "./HotkeyLegend.vue?vue&type=script&lang=ts&"
import style0 from "./HotkeyLegend.vue?vue&type=style&index=0&id=2959afc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959afc1",
  null
  
)

export default component.exports